import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
// actions
import appAction from '../../../redux/actions/app';
// types
import { stateType } from '../../../types/types';
// localization
import strings from '../../../localization';
// style
import './index.scss';

// Full-screen overlay when patient viewport zoom changes during exam prep or test.
const Notification: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const notification = useSelector((state: stateType) => state.app.notification);

  // Navigates to calibration in the same tab and closes the zoom warning.
  const handleReturnToCalibration = () => {
    dispatch(appAction.appNotification(false));
    history.push('/calibration');
  };

  if (!notification) {
    return null;
  }

  return (
    <div className="viewport-warning" role="alert" aria-labelledby="viewport-warning-title">
      <div className="viewport-warning__backdrop" aria-hidden="true" />
      <div className="viewport-warning__panel">
        <h3 id="viewport-warning-title" className="page-heading small light viewport-warning__title">
          {strings.viewportWarning.title}
        </h3>
        <p className="page-description light viewport-warning__description">{strings.viewportWarning.description}</p>
        <div className="viewport-warning__actions">
          <button type="button" className="btn btn_submit viewport-warning__action" onClick={handleReturnToCalibration}>
            {strings.viewportWarning.returnToCalibration}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification;
